import { z } from 'zod';

export enum PaginationDefaults {
  LIMIT = 100,
  MAX_LIMIT = 1000,
}
export const PaginationOrderDirectionEnum = z.enum(['asc', 'desc']);
export const PaginationOrderFieldSchema = z.object({
  field: z.string(),
  order: PaginationOrderDirectionEnum,
});

export const PaginationQueryParamsSchema = z.object({
  skip: z.coerce.number().optional(),
  limit: z.coerce.number().prefault(PaginationDefaults.LIMIT).optional(),
  orderBy: z.array(PaginationOrderFieldSchema).optional(),
});

// preperation for infinit scroll
export const PaginationResponseSchema = z.object({
  total: z.number().optional(),
  skip: z.number().optional(),
  limit: z.number().optional(),
});

export type PaginationOrderDirectionDto = z.infer<
  typeof PaginationOrderDirectionEnum
>;
export type PaginationOrderFieldDto = z.infer<
  typeof PaginationOrderFieldSchema
>;
export type PaginationQueryParamsDto = z.infer<
  typeof PaginationQueryParamsSchema
>;
export type PaginationResponseDto = z.infer<typeof PaginationResponseSchema>;
